"use client";
import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import "./index.css";
import axios from "axios";
import Link from "next/link";
import PageTitle from "@/components/common-components/page-title/PageTitle";
import { generateCacheKey, withManualCache } from "@/utlility/cache-service";

import { useSelector } from "react-redux";
import { fetchNavigationData } from "@/utlility/api-helpers";

export default function SiteMap() {
  const [categories, setCategories] = useState([]);
  const [marketArea, setMarketArea] = useState(null);
  const reduxFeaturesData = useSelector((state) => state?.organization?.featuresData);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Use Redux data if available, otherwise fetch
        const result = reduxFeaturesData || await fetchNavigationData();

        if (result) {
          setCategories(result.categories || []);
          setMarketArea(result.market_area || []);
        }
      } catch (error) {
        // console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [reduxFeaturesData]);

  const activeMarketArea = marketArea?.find((item) => item.is_default);

  const CategoryItem = ({ category, level = 0 }) => {
    const isMain = level === 0;
    return (
      <li className={isMain ? "sitemap-main-item" : "sitemap-sub-item"}>
        {isMain ? (
          <h3 className="sitemap-heading">
            <Link href={`/${category.category_slug}-in-${activeMarketArea?.slug}`}>
              {category.category_name}
            </Link>
          </h3>
        ) : (
          <Link href={`/${category.category_slug}-in-${activeMarketArea?.slug}`}>
            {category.category_name}
          </Link>
        )}

        {category.sub_categories && category.sub_categories.length > 0 && (
          <ul className={`list-unstyled ${isMain ? "" : "ms-3"}`}>
            {category.sub_categories.map((sub, idx) => (
              <CategoryItem key={idx} category={sub} level={level + 1} />
            ))}
          </ul>
        )}
      </li>
    );
  };

  const renderCategories = (categories) => {
    return (
      <ul className="sitemap-list list-unstyled">
        {categories.map((category, index) => (
          <CategoryItem key={index} category={category} />
        ))}
      </ul>
    );
  };

  return (
    <>
      <PageTitle
        image="/images/home/hero/banner.webp"
        name="Sitemap"
      />
      <section>
        <Container data-aos="fade">
          <h2 className="text-center section-title fw-semibold">Main Services <span>Pages</span> </h2>

          <div className="sitemap-container">
            {/* Primary Pages */}
            <h3 className="sitemap-heading">Primary Pages</h3>
            <ul className="sitemap-list list-unstyled">
              <li>
                <Link href="/">Home</Link>
              </li>
              <li>
                <Link href="/about-us">About Us</Link>
              </li>
              <li>
                <Link href="/gallery">Gallery</Link>
              </li>
              <li>
                <Link href="/blog">Blog</Link>
              </li>
              <li>
                <Link href="/contact-us">Contact Us</Link>
              </li>
              <li>
                <Link href="/target-region">Target Region</Link>
              </li>
            </ul>

            {/* Dynamic Categories */}
            {renderCategories(categories)}
          </div>
        </Container>
      </section>
    </>
  );
}
